import Communications from "./containers/Communications/Communications";
import Dashboard from "./containers/Dashboard/Dashboard";
import Accounts from "./containers/Accounts/Accounts";
import Account from "./containers/Accounts/Account/Account";
import Profile from "./containers/Profile/Profile";
import Documentations from './components/Documentations/Documentations';
import Faq from './containers/Faq/Faq';
import ManageAccounts from "./components/Accounts/LinkedAccounts/LinkedAccounts";
import PersonnifyAccounts from "./components/Accounts/LinkedAccounts/PersonnifyAccounts";
import AddLinkedAccountForm from "./components/Accounts/LinkedAccounts/AddLinkedAccount";
import TermsAndConditions from "./containers/TermsAndConditions/TermsAndConditions";
import Payment from "./containers/Payment/Payment";
import Budget from "./containers/Budget/Budget";
import Requests from "./containers/Requests/Requests";
import Tanks from "./containers/Tanks/Tanks";
import Tank from "./containers/Tanks/Tank";

/* name = key in .json */
export default [
    { path: "/", name: 'breadcrumbs.homepage', Component: Dashboard },
    { path: "/documents", name: 'breadcrumbs.communications' , Component: Communications },
    { path: "/accounts", name: 'breadcrumbs.accounts', Component: Accounts },
    { path: "/accounts/change-account", name: 'breadcrumbs.change_account', Component: ManageAccounts },
    { path: "/accounts/change-account/add", name: 'breadcrumbs.change_account_add', Component: AddLinkedAccountForm },
    { path: "/accounts/:id", name: 'breadcrumbs.account', Component: Account },
    { path: "/profile*", name: 'breadcrumbs.profile', Component: Profile },
    { path: "/invoices", name: 'breadcrumbs.docs', Component: Documentations },
    { path: "/personnification", name: 'breadcrumbs.personnification', Component: PersonnifyAccounts },
    { path: "/faq", name: 'breadcrumbs.faq', Component: Faq },
    { path: "/faq-ug", name: 'breadcrumbs.faq', Component: Faq },
    { path: "/conditions", name: 'breadcrumbs.termsandconditions', Component: TermsAndConditions },
    { path: "/privacy", name: 'breadcrumbs.privacy', Component: TermsAndConditions },
    { path: "/payment", name: 'breadcrumbs.payment', Component: Payment },
    { path: "/budget", name: 'breadcrumbs.budget', Component: Budget },
    { path: "/requests", name: 'breadcrumbs.requests', Component: Requests },
    { path: "/tanks", name: 'breadcrumbs.tanks', Component: Tanks },
	{ path: "/tanks/tank/:id", name: 'breadcrumbs.tank', Component: Tank },
];
